import { render } from "./webHeaderDesktop.vue?vue&type=template&id=472b3201&scoped=true&ts=true"
import script from "./webHeaderDesktop.vue?vue&type=script&lang=ts"
export * from "./webHeaderDesktop.vue?vue&type=script&lang=ts"

import "./webHeaderDesktop.vue?vue&type=style&index=0&id=472b3201&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472b3201"]])

export default __exports__